module.exports = __webpack_public_path__ + "img/incloudsphere.704c24b2.svg";